export default "__VITE_ASSET__1LS4Mkcr__"